import { Services, ServicesLabels } from '@consigli/types';
import { FC } from 'react';

import { Combobox, Field, Fieldset } from '@/components';

import { EditOrganizationFormData, FormErrors } from './types';

interface AvailableServicesFieldsProps {
  formData: EditOrganizationFormData;
  errors: FormErrors;
  onFieldChange: (field: keyof EditOrganizationFormData, value: unknown) => void;
}

const serviceOptions = Object.values(Services).map((service) => ({
  value: service,
  label: ServicesLabels[service],
}));

export const AvailableServicesFields: FC<AvailableServicesFieldsProps> = ({
  formData,
  errors,
  onFieldChange,
}) => {
  const handleServicesChange = (selectedServices: string[]) => {
    onFieldChange('availableServices', selectedServices as Services[]);
  };

  return (
    <Fieldset legend="Available Services">
      <Field label="Services" htmlFor="services-combobox" error={errors.availableServices} required>
        <Combobox
          optionGroups={[
            {
              label: 'Services',
              options: serviceOptions,
            },
          ]}
          fallbackLabel="No services found"
          placeholder="Select services..."
          value={formData.availableServices}
          onValueChange={handleServicesChange}
          className="w-full"
          search={true}
          searchPlaceholder="Search services..."
        />
      </Field>
    </Fieldset>
  );
};
